import { useState, ReactNode } from "react";
import { EditSvg } from "../../icons";
import classNames from "classnames";
import StaffModal from "./add-staff-modal";
import { IDepartment, IStaff } from "../../utils/types";
import { queryClient } from "../../App";

interface EditStaffProps {
  data: IStaff;
  showIcon?: boolean;
  Icon?: ReactNode;
  onClose?: () => void;
  defaultOpen?: boolean;
  disabled?: boolean;
  departmentsData: IDepartment[];
  currentStaffAuthMail: string;
}

const EditStaff: React.FC<EditStaffProps> = ({
  data,
  showIcon = true,
  Icon,
  defaultOpen = false,
  disabled,
  departmentsData,
  currentStaffAuthMail,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(defaultOpen);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      {showIcon ? (
        Icon ? (
          <div onClick={disabled ? undefined : openModal}>{Icon}</div>
        ) : (
          <div
            onClick={disabled ? undefined : openModal}
            className={classNames(
              "h-8 w-8 rounded-full bg-[#EFF6FF] flex items-center justify-center hover:bg-[#DBEAFE] transition-colors",
              disabled ? "opacity-50" : "cursor-pointer"
            )}
          >
            <EditSvg color="#6362E7" />
          </div>
        )
      ) : null}

      {isModalOpen && (
        <StaffModal
          staffData={data}
          isEdit={true}
          isOpen={isModalOpen}
          closeModal={() => {
            if (currentStaffAuthMail === data.email)
              queryClient.refetchQueries({ queryKey: ["auth-user"] });
            closeModal();
          }}
          departmentsData={departmentsData}
        />
      )}
    </>
  );
};

export default EditStaff;
